<script>
import ResourceList from '../../../lib/components/ResourceList.vue';
import Deletism from '../../../lib/components/ListActions/Deletism.vue';
import Undeletism from '../../../lib/components/ListActions/Undeletism.vue';
import Archiver from '../../../lib/components/ListActions/Archiver.vue';
import Unarchiver from '../../../lib/components/ListActions/Unarchiver.vue';
import ListAction from '../../../lib/components/ListActions/ListAction.vue';
import Moderator from '../../../lib/components/ListActions/Moderator.vue';
import Tagger from '../../../lib/components/ListActions/Tagger.vue';
import Reviewer from '../../../lib/components/ListActions/Reviewer.vue';
import DuplicateArchiver from '../../../lib/components/ListActions/DuplicateArchiver.vue';
import ContractCreator from '../../../lib/components/ListActions/ContractCreator.vue';

export default {
  components: {
    Deletism,
    Undeletism,
    Archiver,
    Unarchiver,
    ListAction,
    Moderator,
    Reviewer,
    Tagger,
    DuplicateArchiver,
    ContractCreator
  },
  extends: ResourceList,
  computed: {
    taggerRevealed() {
      return this.reveal === 'tagger';
    },
    untaggerRevealed() {
      return this.reveal === 'untagger';
    },
    reviewerRevealed() {
      return this.reveal === 'reviewer';
    },
    duplicateArchiverRevealed() {
      return this.reveal === 'duplicate-archiver';
    },
    contractCreatorRevealed() {
      return this.reveal === 'contract-creator';
    }
  }
};
</script>
